<template>
	<div class="page-content">
		<FixedTool />

		<div class="st-name">
			{{storeName}}<span>(全部共{{classCount}}个班型)</span>
		</div>
		<!-- 列表 -->
		<div class="class-type-lists">
			<nut-infiniteloading :has-more="isHasMore" :is-loading="isLoading" :unload-more-txt="'没有更多了'" @loadmore="onInfinite">
			    <div v-if="classList && classList.length > 0">
					<div class="type-list" v-for="(item, index) in classList" :key="index" @click="routerToDetail(item)">
						<div class="left">
							<div class="top">
								<span class="name">{{item.cat_id1_name}}{{item.title}}</span>
								<div class="type" v-if="item.class_type == 1">拼团</div>
								<span class="price" v-if="item.class_type != 1">￥{{item.shop_price}}</span>
							</div>
							<div class="mid" v-if="item.class_type == 1">
								<span class="single-price">单购价：￥{{item.shop_price}}</span>
								<span class="group-price">{{item.team_user_count}}人团：￥{{item.group_price}}</span>
							</div>
							<div class="bot">
								<div class="advantage">{{item.cat_id2_name}}</div>
								<div class="advantage">{{item.cat_id4_name}}</div>
								<div class="advantage">{{item.time_long}}天拿本</div>
							</div>
						</div>
						<div class="right">
							<div class="join-btn" v-if="item.class_type == 1">参与</div>
							<div class="sign-up-btn" v-else>报名</div>
						</div>
					</div>
				</div>
				<div v-else>
					<empty></empty>
				</div>
				<!-- 根据ui自定义没有更多了样式 -->
				<!-- <div class="no-more-data">
					<div class="line-left"></div>
					<span>没有更多了</span>
					<div class="line-right"></div>
				</div> -->
			</nut-infiniteloading>
		</div>
	</div>
</template>

<script>
import empty from '@/views/Empty'
export default {
	name: 'AllClassType',
	components: {empty},
	data() {
		return {
			store_id: '',
			classCount: 0,
			storeName: '',
			classList: [],
			page: 1,
			classTypeData: [{
				isGroup: true
			}, {
				isGroup: false
			}], //班型数据
      		isHasMore: true, //是否有更多数据可以分页滚动
      		isLoading: false //是否展示加载中动画
    	}
	},
	methods: {
		// 分页请求
		onInfinite() {
			this.isLoading = true;
			this.page++;
			this.getClassList();
		},
		/**
		 * 跳转班型详情
		 * @param {number} id - 班型id
		 */
		routerToDetail(item) {
			if (item.class_type == 1) {
				this.$router.push({ name: 'ClassTypeDetail', query: { team_detail_id: item.id }});
			} else {
				this.$router.push({name: 'ClassDetail', query: {class_id: item.goods_id}});
			}
		},
		getClassList(store_id) {
			this.$ajax.get('m/getlist/class_list', {'activity_id': this.$ajax.get_activity_id(), 'store_id': store_id, page: this.page}).then(res => {
				var pageSize = this.page == 1 ? 15 : 10;
				this.classCount = res.class_count;
				this.storeName = res.store_name;
				if (res.data.length > 0) {
					this.classList = this.classList.concat(res.data);
				}
				if (res.data.length < pageSize) {
					this.isHasMore = false;
				}
				this.isLoading = false;
			});
		}
	},
	created () {
		this.store_id = this.$route.query.store_id;
		this.getClassList(this.$route.query.store_id);
	},
	mounted() {

	}
}
</script>

<style lang="less" scoped>
	.page-content {
		width: 100%;
		.st-name {
			width: 100%;
			height: 52px;
			line-height: 52px;
			box-sizing: border-box;
			padding: 0 15px;
			font-size: 24px;
			font-weight: bold;
			color: #333;
			border-bottom: 1px #E2E2E2 solid;
			span {
				font-size: 12px;
				font-weight: 400;
				color: #666;
			}
		}
		.class-type-lists {
			width: 100%;
			box-sizing: border-box;
			padding: 0 15px;
			.type-list {
				box-sizing: border-box;
				padding: 10px 0;
				display: flex;
				align-items: center;
				justify-content: space-between;
				border-bottom: 1px #E2E2E2 solid;
				.left {
					width: 50%;
					flex: 1;
					.top {
						width: 100%;
						display: flex;
						align-items: center;
						.name {
							font-size: 15px;
							color: #333;
							margin-right: 5px;
						}
						.type {
							width: 32px;
							height: 18px;
							background-color: #FF808E;
							border-radius: 3px;
							font-size: 12px;
							color: #fff;
							text-align: center;
							line-height: 18px;
						}
						.price {
							font-size: 18px;
							color: #EB273B;
						}
					}
					.mid {
						width: 100%;
						display: flex;
						align-items: center;
						margin-top: 10px;
						.single-price {
							font-size: 13px;
							color: #666;
							margin-right: 10px;
						}
						.group-price {
							font-size: 14px;
							color: #EB273B;
						}
					}
					.bot {
						width: 100%;
						display: flex;
						flex-wrap: wrap;
						margin-top: 10px;
						.advantage {
							height: 18px;
							line-height: 18px;
							display: flex;
							align-items: center;
							text-align: center;
							border-radius: 3px;
							margin-right: 5px;
							font-size: 12px;
							color: #868686;
							box-sizing: border-box;
							padding: 0 5px;
              background-color: #fafafa;
						}
					}
				}
				.right {
					div {
						width: 60px;
						height: 28px;
						line-height: 28px;
						text-align: center;
						border-radius: 15px;
						font-size: 12px;
					}
					.join-btn {
						border: 1px #3C43EC solid;
						color: #3C43EC;
					}
					.sign-up-btn {
						border: 1px #EB273B solid;
						color: #EB273B;
					}
				}
			}
			.type-list:first-child {
				//margin-top: 10px;
			}
		}
	}
</style>
